export default __webpack_public_path__ + "static/media/PIL_Dashboard.9ae74057.svg";